export default __webpack_public_path__ + "static/media/angered.9c9d9011.png";